(function () {
  const body = document.body;
  const menu = document.querySelector("[data-mobile-menu]");
  if (!menu) return;

  const openBtn = document.querySelector("[data-menu-open]");
  const closeBtn = document.querySelector("[data-menu-close]");
  const overlay = document.querySelector("[data-menu-overlay]");
  const panel = menu.querySelector(".mobile-menu__panel");
  const focusableSelector =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let lastFocusedElement = null;

  function getFocusableElements() {
    return Array.from(panel.querySelectorAll(focusableSelector)).filter((el) => {
      const submenu = el.closest("[data-mobile-submenu]");
      if (!submenu) return true;
      return submenu.closest(".mobile-menu__item--has-submenu")?.classList.contains("is-open");
    });
  }

  function collapseSubmenus() {
    menu.querySelectorAll(".mobile-menu__item--has-submenu.is-open").forEach((item) => {
      item.classList.remove("is-open");
      item.querySelector("[data-mobile-submenu-toggle]")?.setAttribute("aria-expanded", "false");
    });
  }

  function openMenu() {
    lastFocusedElement = document.activeElement;
    menu.classList.add("is-open");
    menu.setAttribute("aria-hidden", "false");
    openBtn?.setAttribute("aria-expanded", "true");
    body.classList.add("is-menu-open");

    const focusable = getFocusableElements();
    focusable[0]?.focus();
  }

  function closeMenu() {
    menu.classList.remove("is-open");
    menu.setAttribute("aria-hidden", "true");
    openBtn?.setAttribute("aria-expanded", "false");
    body.classList.remove("is-menu-open");
    collapseSubmenus();

    if (lastFocusedElement instanceof HTMLElement) {
      window.setTimeout(() => {
        lastFocusedElement.focus();
      }, 350);
    }
  }

  function trapFocus(event) {
    if (!menu.classList.contains("is-open") || event.key !== "Tab") return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  openBtn?.addEventListener("click", openMenu);
  closeBtn?.addEventListener("click", closeMenu);
  overlay?.addEventListener("click", closeMenu);

  menu.querySelectorAll(".mobile-menu__link, .mobile-menu__submenu-link").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  menu.querySelectorAll("[data-mobile-submenu-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".mobile-menu__item--has-submenu");
      if (!item) return;

      const isOpen = item.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && menu.classList.contains("is-open")) {
      closeMenu();
    }

    trapFocus(event);
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 768 && menu.classList.contains("is-open")) {
      closeMenu();
    }
  });
})();
